exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2rFe9Eavw9OYJV9btTQfdH{width:16px;height:16px}html[dir] ._2rFe9Eavw9OYJV9btTQfdH{padding:7px}._3VxZo3VujIF36VYTy2QkM_{width:30px;height:30px;cursor:pointer}html[dir] ._3VxZo3VujIF36VYTy2QkM_{background-color:transparent;padding:0}html[dir=ltr] ._3VxZo3VujIF36VYTy2QkM_{margin:0 5px 0 0}html[dir=rtl] ._3VxZo3VujIF36VYTy2QkM_{margin:0 0 0 5px}html[dir] ._3VxZo3VujIF36VYTy2QkM_:hover{background-color:\"[theme:themeLighter, default:#DEECF9]\"}._3VxZo3VujIF36VYTy2QkM_ .ms-Button-menuIcon{display:none}", ""]);

// exports
exports.locals = {
	"image": "_2rFe9Eavw9OYJV9btTQfdH",
	"addinEntryButton": "_3VxZo3VujIF36VYTy2QkM_"
};